import { GlobalEnumsAceXfoundportalobjekt } from '@/api/model-index';
import { FocusService } from '@/core/services/focus.service';
import { FocusManagedDialogComponent } from '@/core/components/dialogs/focus-managed-dialog.component';
import { Component, Input, OnDestroy } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-chat-dialog',
  templateUrl: './chat-dialog.component.html',
  styleUrls: ['./chat-dialog.component.scss']
})
export class ChatDialogComponent extends FocusManagedDialogComponent{
  @Input()
  public anfrageId: string;
  @Input()
  public scope: GlobalEnumsAceXfoundportalobjekt;
  @Input()
  public anfrageTitel: string;

  constructor(dialog: DialogRef, protected focusService: FocusService) {
    super(focusService, dialog);
  }
}
